import { useTranslation } from "react-i18next";

import Form from "../../../forms/components/Form/Form";

export const options = [
	{ key: "88", value: "88", text: "8.8 Lydbøker lydfil for allmennmarkedet", disabled: true },
	{ key: "881", value: "8x1", text: "8.x.1 Norsk sakprosa for voksne" },
	{ key: "882", value: "8x2", text: "8.x.2 Norsk skjønnlitteratur for voksne" },
	{ key: "883", value: "8x3", text: "8.x.3 Oversatt sakprosa for voksne" },
	{ key: "884", value: "8x4", text: "8.x.4 Oversatt skjønnlitteratur for voksne" },
	{ key: "885", value: "8x5", text: "8.x.5 Norsk sakprosa for barn og ungdom" },
	{ key: "886", value: "8x6", text: "8.x.6 Norsk skjønnlitteratur for barn og ungdom" },
	{ key: "887", value: "8x7", text: "8.x.7 Oversatt sakprosa for barn og ungdom" },
	{ key: "888", value: "8x8", text: "8.x.8 Oversatt skjønnlitteratur for barn og ungdom" },
	{ key: "880", value: "8x0", text: "8.x.0 Diverse" },
];

export default function WorkMetaDataBokgruppeSelect({ name }) {
	const { t } = useTranslation();

	return <Form.Select label={t("bokgruppe", "Bokgruppe")} search allowEmpty options={options} name={name} />;
}
